import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [reportingCcy, setReportingCcy] = useState(localStorage.getItem("barjeel_ccy") || "USD");
  const [theme, setTheme] = useState(localStorage.getItem("barjeel_theme") || "light");

  useEffect(() => {
    const token = localStorage.getItem("barjeel_token");
    if (!token) { setLoading(false); return; }
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => {
      localStorage.removeItem("barjeel_token");
    }).finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    document.documentElement.classList.toggle("dark", theme === "dark");
    localStorage.setItem("barjeel_theme", theme);
  }, [theme]);

  useEffect(() => { localStorage.setItem("barjeel_ccy", reportingCcy); }, [reportingCcy]);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    localStorage.setItem("barjeel_token", r.data.token);
    setUser(r.data.user);
    return r.data.user;
  };

  const logout = () => {
    localStorage.removeItem("barjeel_token");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, reportingCcy, setReportingCcy, theme, setTheme }}>
      {children}
    </AuthContext.Provider>
  );
}
